// ported from jQuery's $.type
var classToType = {};
for (var _i = 0, _arr = ['Boolean', 'Number', 'String', 'Function', 'Array', 'Date', 'RegExp', 'Undefined', 'Null']; _i < _arr.length; _i++) {
  var name = _arr[_i];
  classToType["[object ".concat(name, "]")] = name.toLowerCase();
}
export default function (obj) {
  return classToType[Object.prototype.toString.call(obj)] || 'object';
}